<template>
  <div class="itemsContent">

    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="date" label="" min-width="180">
        <template slot-scope="scope">
          <div>
            {{ scope.row.workshopChildProcess.name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="date"
        :label="language('workShop.实际工时')"
        width="300"
      >
        <template slot-scope="scope">
          <div class="list">
            <!-- <el-input v-model="input" placeholder=""></el-input> -->
            <el-select
              v-model="scope.row.workshopChildProcess.hour"
              clearable
              placeholder=""
              filterable
              @change="hourChange"
              :disabled="scope.row.workshopChildProcess.surplusWorkingHours<=0?true:false"
            >
              <el-option
                v-for="(item, index) in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                v-if="
                  scope.row.workshopChildProcess.surplusWorkingHours >= index
                "
              >
              </el-option>
            </el-select>
            <span>{{ language("workShop.小时") }}</span>
            <!-- <el-input placeholder="" v-model="input"></el-input> -->
            <el-select
              v-model="scope.row.workshopChildProcess.minute"
              clearable
              placeholder=""
              filterable
              @change="minuteChange"
              :disabled="scope.row.workshopChildProcess.surplusWorkingHours<=0?true:false"

            >
              <el-option
                v-for="item in options2"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <span>{{ language("workShop.分钟") }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        :label="language('workShop.剩余工时')"
        width="250"
      >
        <template slot-scope="scope">
          <div class="list">
            <span>
              {{ getHour(scope.row.workshopChildProcess.surplusWorkingHours)
              }}{{ language("workShop.小时") }}</span
            >
            <span
              >{{ getMinute(scope.row.workshopChildProcess.surplusWorkingHours)
              }}{{ language("workShop.分钟") }}</span
            >
          </div>
        </template>
      </el-table-column>
      <el-table-column
        width="200"
        prop="address"
        :label="language('workShop.报工上限工时')"
      >
        <template slot-scope="scope">{{
          scope.row.workshopChildProcess.limitWorkingHours
        }}</template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
let options2 = [];
for (let index = 0; index < 60; index++) {
  options2.push({
    value: index,
    label: index,
  });
}
let options = [];
for (let index = 0; index < 25; index++) {
  options.push({
    value: index,
    label: index,
  });
}
export default {
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    formData: {
      type: Object,
      required: false,
    },
  },
  watch: {
    "formData.ids": {
      handler() {
        // console.log(this.formData,this.formData.ids &&
        //   this.formData.ids.ids.length == 4 &&
        //   this.formData &&

        //   this.formData.workshopDailyDetailsRelList.length == 0);
        if (
          this.formData &&
          this.formData.ids &&
          this.formData.ids.ids.length == 4
        ) {
          // this.nun = 2;
          this.getData();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      tableData: [],
      options: options,
      options2: options2,
      nun: 1,
    };
  },
  methods: {
    getHour(num) {
      let n = num + "";
      if (n.indexOf(".") > -1) {
        return n.split(".")[0];
      }
      return n;
    },
    getMinute(num) {
      let n = num + "";
      if (n.indexOf(".") > -1) {
        //60分钟视为1， 每分钟约0.0166666666666667
        let minute = "0" + n.split(".")[1];
        minute = minute / 10;
        let text = (minute / 0.0166666666666667).toFixed(0);
        return text;
      } else {
        return 0;
      }
    },
    hourChange() {
      this.calculateTime();
    },
    minuteChange() {
      this.calculateTime();
    },
    calculateTime() {
      let actualWorkingHours = 0;
      let actualWorkingHoursV2 = 0;
      let data = [...this.tableData];
      let text = "";
      for (let index = 0; index < data.length; index++) {
        let hour = data[index].workshopChildProcess.hour || 0;
        let minute = data[index].workshopChildProcess.minute || 0;
        minute = (minute * 0.0166666666666667).toFixed(1);
        data[index].workshopChildProcess.actualWorkingHours =
          hour * 1 + minute * 1;
        actualWorkingHours += hour * 1 + minute * 1;
        actualWorkingHoursV2 += hour * 1 

        if (
          data[index].workshopChildProcess.surplusWorkingHours>=0 &&
          this.getHour(data[index].workshopChildProcess.surplusWorkingHours) <
          hour
        ) {
          data[index].workshopChildProcess.hour = "";
          text = "实际工时不能大于剩余工时";
          break;
        } else {
          if (
            this.getHour(
              data[index].workshopChildProcess.surplusWorkingHours
            ) == hour
          ) {
            if (
              this.getMinute(
                data[index].workshopChildProcess.surplusWorkingHours
              ) < data[index].workshopChildProcess.minute
            ) {
              data[index].workshopChildProcess.minute = "";
              text = "实际工时不能大于剩余工时";
            }
          }
        }
      }
      if (text) {
        this.$message.error(text);
        this.formData.actualWorkingHours = actualWorkingHoursV2;
      } else {
        this.formData.actualWorkingHours = actualWorkingHours;
      }

      console.log(this.formData, 11111);
      this.$emit("change", this.tableData);
    },
    getData() {
      this.ccRequest
        .do(
          `admin/fsb/workshop/daily/dailyInfo/query?type=4`,
          {
            ids: this.formData.ids.ids[3],
            userId: 1,
            pageNo: 1,
            pageSize: 10000,
          },
          "GET"
        )
        .then((res) => {
          for (let index = 0; index < res.rows.length; index++) {
            res.rows[index].workshopChildProcess.actualWorkingHours = "";
            res.rows[index].workshopChildProcess.hour = "";
            res.rows[index].workshopChildProcess.minute = "";
          }
          this.tableData = res.rows;
          console.log(this.tableData);
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
        });
    },
  },
  mounted() {
    console.log(this.formData);
    if (this.formData.ids) {
      this.tableData = JSON.parse(
        JSON.stringify(this.formData.workshopDailyDetailsRelList)
      );
      for (let index = 0; index < this.tableData.length; index++) {
        this.tableData[index].workshopChildProcess.hour = this.getHour(
          this.tableData[index].actualWorkingHours
        );
        let n = this.tableData[index].actualWorkingHours + "";
        if (n.indexOf(".") > -1) {
          let minute = n.split(".")[1];
          this.tableData[index].workshopChildProcess.minute = minute * 50;
        }
      }
      if (this.formData.content) {
        this.formData.ids.name[3] = this.formData.content;
      }
      console.log(this.tableData, "tableData");
    }
  },
};
</script>
<style>
.itemsContent .cell {
  text-align: center;
}
.itemsContent input {
  /* width: 60px; */
}
</style>
<style lang="scss" scoped>
.list {
  display: flex;
  align-items: center;
  justify-content: center;
}
span {
  margin-left: 5px;
  display: block;
  min-width: 40px;
}
</style>